import { renderApp } from "@ui-seeker/app"

import AppTest from "./App"


renderApp(AppTest, {
    useServiceWorker: process?.env?.NODE_ENV === 'production'
})